<template>
  <div class="w-full flex gap-2 justify-between">
    <FormKit
      id="share-password-input"
      autocomplete="off"
      type="password"
      suffix-icon="general.eye"
      data-testid="share-password-input"
      v-model="password"
      validation="required"
      validation-label="Password"
      @suffix-icon-click="handleIconClick"
      suffix-icon-class="cursor-pointer hover:text-blue-500"
    />
    <Button type="solid" variant="blue" :disabled="passwordDisabled" data-testid="share-password-set" @click.prevent="password && changePassword(password)"
      >Set password</Button
    >
  </div>
  <div class="mt-2 flex gap-4 items-center justify-start">
    <button class="inline-button flex gap-1 items-center text-blue-500" data-testid="share-password-generate" @click.prevent="password = generatePassword()">
      <Icon size="sm" name="general.key" />
      <span>Suggest password</span>
    </button>
    <button class="inline-button flex gap-1 items-center text-blue-500" data-testid="share-password-copy" @click.prevent="copy()">
      <Icon size="xs" name="general.copyDocument" />
      <span>Copy to clipboard</span>
    </button>
  </div>
</template>
<script setup lang="ts">
import { computed, ref, Ref, watch } from 'vue';
import { useClipboard } from '@vueuse/core';
import { FormKitNode } from '@formkit/core';
import { Icon } from '@/storybook/icon';
import { Button } from '@/storybook/button';
import { usePassword } from '@/composables/usePassword';
import { useToast } from '@/composables/useToast';
import { useSecurity } from '@/modules/viewer/composables/useSecurity';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';

const viewerItemStore = useViewerItemStore();

const { changePassword } = useSecurity();
const { generatePassword } = usePassword();
const { success } = useToast();

const password = ref(viewerItemStore.password);
const { copy, copied } = useClipboard({ source: password as Ref });

const handleIconClick = (node: FormKitNode) => {
  node.props.suffixIcon = node.props.suffixIcon === 'general.eye' ? 'general.eyeDisabled' : 'general.eye';
  node.props.type = node.props.type === 'password' ? 'text' : 'password';
};

const passwordDisabled = computed(() => !password.value || password.value === viewerItemStore.password);

watch(copied, res => {
  if (!res) {
    return;
  }

  success('Password copied to clipboard', { icon: 'general.copy' });
});
</script>
